<template>
  <div class="middle-bottom">
    <a-card>
      <a-card-grid @click="show_img(item)" class="item" v-for="(item, index) in list" :key="index">
        <img src="../../assets/dongti/person.png" class="icon" />
        <div class="info">
          <div class="no">岗位 No.{{ item.number }}</div>
          <div class="line" :style="`background-color: ${item.color}`"></div>
          <div class="status">{{ item.status_text }}</div>
        </div>
      </a-card-grid>
    </a-card>
    <a-modal v-model="visible" :width="800" title="岗位查看" :footer="null">
      <div class="img-area">
        <img :src="current_src" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

let timer = null

export default {
  data() {
    return {
      list: [],
      visible: false,
      current_src: '',
    }
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
  },
  destroyed() {
    clearInterval(timer)
  },
  mounted() {
    this.get_data()

    timer = setInterval(() => {
      this.get_data()
    }, 10000)
  },
  methods: {
    show_img(row) {
      this.current_src = ''
      if (process.env.NODE_ENV == 'development') {
        this.current_src = 'http://192.168.8.100:9000' + row.info.image_url
      } else {
        this.current_src = row.info.image_url
      }
      this.$nextTick(() => {
        this.visible = true
      })
    },
    get_data() {
      this.$http({
        url: 'stadium/positions',
        method: 'post',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        r.forEach((row) => {
          if (row.working) {
            if (row.position_status * 1 === 1) {
              row.color = '#4A90E2'
              row.status_text = '人员已就绪'
            } else if (row.position_status * 1 === 0) {
              row.color = '#E12929'
              row.status_text = '人员离岗'
            } else if (row.position_status * 1 === -1) {
              row.color = '#999'
              row.status_text = '未知'
            }
          } else {
            row.color = '#999'
            row.status_text = '不在工作时间'
          }
        })
        this.list = r
      })
    },
  },
}
</script>

<style lang="less" scoped>
.img-area {
  width: 100%;
  img {
    width: 100%;
  }
}
.middle-bottom {
  color: #fff;
  padding: 0 30px;
  margin-top: 18px;
  .item {
    display: flex;
    align-items: flex-start;
    .icon {
      width: 50px;
      height: 50px;
      margin-right: 24px;
    }
    .no {
      font-size: 16px;
      color: #07c2ee;
    }
    .line {
      height: 13px;
      width: 200px;
      background: #ffdb5c;
      border: 2px solid #1e2739;
      border-radius: 6px;
      margin: 12px 0 4px;
    }
    .status {
      font-size: 14px;
    }
  }
  /deep/ .ant-card {
    background-color: transparent;
    color: #fff;
    &.ant-card-bordered {
      border: none;
    }
    .ant-card-grid {
      box-shadow: 0 0 0 0 #447092;
      padding: 5px 20px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0.1vw 0.42vw rgba(81, 209, 248, 0.8);
      }
    }
  }
}
</style>
